import { render, staticRenderFns } from "./404.vue?vue&type=template&id=0a81539c&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=0a81539c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a81539c",
  null
  
)

export default component.exports